import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import "./kaban.scss";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import interactionPlugin from "@fullcalendar/interaction";
import * as ReactBootstrap from "react-bootstrap";
import cross from "../../assets/icons/cross-close.svg";
const KabanBoard = () => {
  const tradesData = useSelector((state) => state.dashboard.tradesData) || [];
  console.log(tradesData,'trandeData')
  function handleEventMount(info) {
    if (info.event.extendedProps.type === "profit") {
      const eventWrapper = info.el.closest(".fc-daygrid-day-frame");
      if (eventWrapper) {
        eventWrapper.classList.add("profit-grid"); // Add a custom class for Profit events
      }
    }
    if (info.event.extendedProps.type === "loss") {
      const eventWrapper = info.el.closest(".fc-daygrid-day-frame");
      if (eventWrapper) {
        eventWrapper.classList.add("loss-grid"); // Add a custom class for Profit events
      }
    }
  }

  const [events, setEvents] = useState([]);
  useEffect(() => {
    const eventsData = Object.entries(tradesData).flatMap(([date, data]) => {
      const { trades, profitSum } = data;
      return {
        title: trades[0]?.symbol, // Provide a suitable title for each event
        start: date,
        end: date,
        color: profitSum > 0 ? "#010101" : "#FF0000",
        extendedProps: {
          trade: `${profitSum > 0 ? "$" : "-$"}${Math.abs(profitSum).toFixed(
            2
          )}/Trade`,
          type: profitSum > 0 ? "profit" : "loss",
        },
      };
    });

    setEvents(eventsData);
  }, [tradesData]);
  // CODE FOR ALL EVENTS AND TRADING INSTANCES/
  // useEffect(() => {
  //   const eventsData = Object.entries(tradesData).flatMap(([date, data]) => {
  //     const { trades, profitSum } = data;

  //     return trades.map((trade) => {
  //       const { symbol, dateOpen, dateClose } = trade;

  //       return {
  //         title: symbol,
  //         start: date,
  //         end: date,
  //         color: profitSum > 0 ? "#010101" : "#FF0000",
  //         extendedProps: {
  //           trade: `${profitSum > 0 ? "$" : "$"}${Math.abs(profitSum).toFixed(
  //             2
  //           )}K/Trade`,
  //           type: profitSum > 0 ? "profit" : "loss",
  //         },
  //       };
  //     });
  //   });

  //   setEvents(eventsData);
  //   console.log(eventsData);
  // }, [tradesData]);

  // const events = [
  //   {
  //     title: "$120K",
  //     start: "2023-12-01",
  //     end: "2023-12-01",

  //     color: "#010101",

  //     extendedProps: {
  //       trade: "$200K/Trade",
  //       type: "profit",
  //     },
  //   },
  //   {
  //     title: "$120K",
  //     start: "2023-12-09",
  //     end: "2023-12-09",

  //     //   className: "profit",
  //     color: "#010101",

  //     extendedProps: {
  //       trade: "$200K/Trade",
  //       type: "loss",
  //       // customContent: `<div class='custom-div'>  <b>"$200K/Trade"</b> </div>`,
  //     },
  //   },
  //   {
  //     title: "$120K",
  //     start: "2023-12-03",
  //     end: "2023-12-04",

  //     //   className: "profit",
  //     color: "transparent",

  //     extendedProps: {
  //       trade: "$200K/Trade",
  //       type: "loss",
  //       // customContent: `<div class='custom-div'>  <b>"$200K/Trade"</b> </div>`,
  //     },
  //   },
  // ];
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTrade, setSelectedTrade] = useState(null);

  const handleDateClick = (arg) => {
    // this check if tradesData contains any trade for the clicked date
    const trade = tradesData[arg.dateStr];
    if (trade) {
      setSelectedTrade(trade);
      setIsModalOpen(true);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedTrade(null);
  };
  return (
    <div className="kaban_wrapper">
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        weekends={true}
        events={events}
        selectable={true}
        eventContent={renderEventContent}
        eventClassNames="custom_event"
        eventDidMount={handleEventMount}
        dateClick={handleDateClick}
        height={"auto"}
        headerToolbar={{
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,dayGridYear",
        }}
      />
      {isModalOpen && (
        <TradeModal
          date={tradesData}
          isOpen={isModalOpen}
          closeModal={closeModal}
          trade={selectedTrade}
        />
      )}
    </div>
  );
};

function renderEventContent(eventInfo) {
  return (
    <div className="event_wrapper">
      <b>{eventInfo.event.title}</b>
      <div className={eventInfo.event.extendedProps.type}>
        {eventInfo.event.extendedProps.trade}
      </div>
      {/* <div
        dangerouslySetInnerHTML={{
          __html: eventInfo.event.extendedProps.customContent,
        }}
      /> */}
    </div>
  );
}

export default KabanBoard;

const TradeModal = ({ isOpen, closeModal, trade, date }) => {
  const modalRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, closeModal]);
  console.log(trade);
  const tradeKeys = Object.keys(trade.trades[0]);
  console.log(tradeKeys);
  const formatDate = (dateString) => {
    const options = { hour: "numeric", minute: "numeric", second: "numeric" };
    return new Date(dateString).toLocaleTimeString(undefined, options);
  };
  const dates = Object.keys(date);
  const extractedDate = dates.length > 0 ? dates[0] : null;

  const formattedDate = extractedDate
    ? new Date(extractedDate).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : null;

  console.log(formattedDate);

  return (
    <div className={`trade-modal ${isOpen ? "open" : ""}`}>
      <div className="modal_content" ref={modalRef}>
        <div className="modal_header">
          <p>{formattedDate}</p>
          <button className="close-button" onClick={closeModal}>
            <img src={cross} alt="" />
          </button>
        </div>
        {trade && (
          <div style={{ marginTop: "20px" }}>
            <div className="PageContainer LeaderboardPage PaymentHistoryPage mtt-20">
              <div className="HistoryDesk">
                <ReactBootstrap.Table className="LeaderboardTable">
                  <thead>
                    <tr style={{ textWrap: "nowrap" }}>
                      <th>Action</th>
                      <th>Commission Sum</th>
                      <th>Date Close</th>
                      <th>Date Open</th>
                      <th>Login</th>
                      <th>Position</th>
                      <th>Price Avg Buy</th>
                      <th>Price Avg Sell</th>
                      <th>Profit Sum</th>
                      <th>Stop Loss</th>
                      <th>Swap Sum</th>
                      <th>Symbol</th>
                      <th>Take Profit</th>
                      <th>Volume Sum Buy</th>
                      <th>Volume Sum Sell</th>
                    </tr>
                  </thead>
                  <tbody>
                    {trade.trades.map((trade, index) => (
                      <tr key={index}>
                        <td>{trade.action}</td>
                        <td>{trade.commissionSum}</td>
                        <td>{formatDate(trade.dateClose)}</td>
                        <td>{formatDate(trade.dateOpen)}</td>
                        <td>{trade.login}</td>
                        <td>{trade.position}</td>
                        <td>{trade.priceAvgBuy}</td>
                        <td>{trade.priceAvgSell}</td>
                        <td
                          className={`${trade.profitSum > 0 ? "green" : "red"}`}
                        >
                          {trade.profitSum}
                        </td>
                        <td>{trade.stopLoss}</td>
                        <td>{trade.swapSum}</td>
                        <td>{trade.symbol}</td>
                        <td>{trade.takeProfit}</td>
                        <td>{trade.volumeSumBuy}</td>
                        <td>{trade.volumeSumSell}</td>
                      </tr>
                    ))}
                  </tbody>
                </ReactBootstrap.Table>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
